import { render, staticRenderFns } from "./VideoInBrowser.vue?vue&type=template&id=2c852dbe&scoped=true"
import script from "./VideoInBrowser.vue?vue&type=script&lang=js"
export * from "./VideoInBrowser.vue?vue&type=script&lang=js"
import style0 from "./VideoInBrowser.vue?vue&type=style&index=0&id=2c852dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c852dbe",
  null
  
)

export default component.exports